const media = {
  addMedia: null,
  fetchMedia: null,
  deleteMedia: null,
};

export default media;
